import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';

const logo = `${process.env.PUBLIC_URL}/logo-original.png`;

function ProfileDetailsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const profileId = searchParams.get('id');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const isValidId = profileId && UUID_RE.test(profileId);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (!isValidId) {
      setError('Invalid profile ID');
      setLoading(false);
      return;
    }

    // TODO: Replace with actual API call
    // For now, this is a placeholder for fetching profile data
    const fetchProfile = async () => {
      try {
        setLoading(true);
        // TODO: Replace with your actual API endpoint:
        // const response = await fetch(`/api/profiles/${profileId}`);
        // if (!response.ok) throw new Error('Profile not found');
        // const data = await response.json();
        // setProfileData(data);
        
        // Placeholder: Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // For development: Just finish loading
        // Profile data will be fetched and displayed once API is integrated
        
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError('Failed to load profile. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [profileId, isValidId]);

  if (!isValidId) {
    return (
      <div className="App">
        <nav className="navbar">
          <div className="container">
            <div className="nav-content">
              <div className="logo">
                <Link to="/" aria-label="Zivug Mishamayim home">
                  <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
                </Link>
              </div>
              <div className="nav-links">
                <Link to="/">Home</Link>
                <Link to="/donate">Donate</Link>
              </div>
            </div>
          </div>
        </nav>

        <main className="share-landing">
          <div className="share-card">
            <img src={logo} alt="Zivug Mishamayim" className="share-logo" />
            <h1 className="share-title">Invalid Profile Link</h1>
            <p className="share-subtitle">
              This link doesn't point to a valid profile. Please check the URL or return to the home page.
            </p>
            <button 
              className="share-btn share-btn-primary" 
              onClick={() => navigate('/')}
            >
              Go to Home
            </button>
          </div>
        </main>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="App">
        <nav className="navbar">
          <div className="container">
            <div className="nav-content">
              <div className="logo">
                <Link to="/" aria-label="Zivug Mishamayim home">
                  <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
                </Link>
              </div>
              <div className="nav-links">
                <Link to="/">Home</Link>
                <Link to="/donate">Donate</Link>
              </div>
            </div>
          </div>
        </nav>

        <main className="share-landing">
          <div className="share-card">
            <img src={logo} alt="Zivug Mishamayim" className="share-logo" />
            <h1 className="share-title">Loading Profile...</h1>
            <p className="share-subtitle">Please wait while we fetch the profile details.</p>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <nav className="navbar">
          <div className="container">
            <div className="nav-content">
              <div className="logo">
                <Link to="/" aria-label="Zivug Mishamayim home">
                  <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
                </Link>
              </div>
              <div className="nav-links">
                <Link to="/">Home</Link>
                <Link to="/donate">Donate</Link>
              </div>
            </div>
          </div>
        </nav>

        <main className="share-landing">
          <div className="share-card">
            <img src={logo} alt="Zivug Mishamayim" className="share-logo" />
            <h1 className="share-title">Error Loading Profile</h1>
            <p className="share-subtitle">{error}</p>
            <button 
              className="share-btn share-btn-primary" 
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <Link to="/" aria-label="Zivug Mishamayim home">
                <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
              </Link>
            </div>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/donate">Donate</Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="share-landing">
        <div className="share-card">
          <img src={logo} alt="Zivug Mishamayim" className="share-logo" />
          
          <h1 className="share-title">Profile Details</h1>
          
          {/* TODO: Replace this section with actual profile display */}
          <div style={{ padding: '20px', textAlign: 'left' }}>
            <p className="share-subtitle">
              This page will display the full profile details for profile ID: {profileId}
            </p>
            <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
              <strong>Note for developers:</strong> This is a placeholder. Integrate with your backend API 
              to fetch and display actual profile information here.
            </p>
            <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
              Consider displaying: profile photo, name, age, location, bio, interests, etc.
            </p>
          </div>

          <div className="share-divider">
            <span>View in mobile app for full experience</span>
          </div>

          <div className="share-store-buttons">
            <button
              className="share-btn share-btn-store"
              disabled
              style={{ opacity: 0.6, cursor: 'not-allowed' }}
            >
              App Store - Coming Soon
            </button>
            <a
              href="https://play.google.com/store/apps/details?id=com.zivugmishamayim&pli=1"
              className="share-btn share-btn-store"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get it on Google Play
            </a>
          </div>

          <p className="share-footer-note">
            <Link to="/support">Support</Link>
            {' · '}
            <Link to="/privacy">Privacy Policy</Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default ProfileDetailsPage;
